<script>
    import _ from 'lodash'
    /* import NurseService from '@/request/aims/nurse'
    import anesthesiaModeService from '@/request/aims/anesthesiaMode'
    import AnesthesiologistService from '@/request/aims/anesthesiologist' */
    import OperationService from '@/request/aims/operation'
    export default {
        name: 'AimsOperationSelection',
        props: {
            operation: {
                type: Object,
                default () {
                    return {}
                }
            },
            type: {
                type: String,
                default: ''
            },
            hospital: {
                type: Number,
                default: 0
            },
            selection: Array,
            additionals: Array,
        },
        data () {
            return {
                text: '',
                valueKey: null,
                nameKey: null,
                // selection: [],
                title: '请选择',
                selecting: false,
                selected: [],
                additionalMap: {},
                old: [],
                displayed: false,
                saving: false,
                single: false
            }
        },
        computed: {},
        created: function () {
            this.init()
        },
        mounted: function () {},
        beforeDestroy () {},
        watch: {
            operation () {
                this.init()
            },
            type () {
                if (this.displayed) {
                    this.createData()
                }
            },
            hospital () {
                if (this.displayed) {
                    this.createData()
                }
            },
            displayed (val) {
                if (val) {
                    this.createData()
                }
            }
        },
        methods: {
            init () {
                if (_.isEmpty(this.operation)) {
                    this.text = ''
                    this.selected = []
                    this.old = []
                    return
                }
                if (!_.isEmpty(this.additionals)) {
                    let map = {}
                    _.forEach(this.selection, item => {
                        if (this.operation.anesthesiaAdditional && this.operation.anesthesiaType === item.name) {
                            map[item.name] = this.operation.anesthesiaAdditional
                            return
                        }
                        map[item.name] = this.additionals[0]['operation']
                    })
                    this.additionalMap = map
                }
                switch (this.type) {
                    case 'washNurse':
                        this.title = '请选择人员'
                        this.valueKey = 'washNurse'
                        this.nameKey = 'washNurseName'
                        this.text = this.operation.washNurseName ? this.operation.washNurseName : (this.operation.needWashNurse === 0 ? '不需要' : '需要')
                        break
                    case 'tourNurse':
                        this.title = '请选择人员'
                        this.valueKey = 'tourNurse'
                        this.nameKey = 'tourNurseName'
                        this.text = this.operation.tourNurseName ? this.operation.tourNurseName : (this.operation.needTourNurse === 0 ? '不需要' : '需要')
                        break
                    case 'anesthesiaDoc':
                        this.title = '请选择人员'
                        this.valueKey = 'anesthesiaDoc'
                        this.nameKey = 'anesthesiaDocName'
                        this.text = this.operation.anesthesiaDocName ? this.operation.anesthesiaDocName : '未安排'
                        break
                    case 'anesthesiaType':
                        this.title = '请选择类型'
                        this.valueKey = 'anesthesiaType'
                        this.nameKey = null
                        this.text = this.operation.anesthesiaType ? (this.operation.anesthesiaAdditional ? this.operation.anesthesiaType + '(' + this.operation.anesthesiaAdditional + ')' : this.operation.anesthesiaType) : '点击选择'
                        break
                }
                let ids = null
                if (this.valueKey) {
                    let str = this.operation[this.valueKey]
                    if (str && str.indexOf('(') === 0) {
                        str = str.substring(1, str.length - 1)
                        ids = _.map(_.split(str, ')('), _.parseInt)
                    } else {
                        ids = str ? _.split(str, ',') : []
                    }
                }
                this.old = _.cloneDeep(ids || [])
                this.selected = _.cloneDeep(ids || [])
            },
            createData () {
                if (this.type === 'anesthesiaType') this.single = true
                this.selectTable()
            },
            selectTable () {
                if (this.selecting) {
                    return
                }
                this.selecting = true
                this.$nextTick(() => {
                    if (!this.$refs.selectionTable) {
                        this.selecting = false
                        return
                    }
                    this.$refs.selectionTable.clearSelection()
                    if (!_.isEmpty(this.selected) && !_.isEmpty(this.selection)) {
                        _.forEach(this.selected, value => {
                            if (_.isObject(value)) {
                                value = value.uid || null
                            }
                            let key = _.isString(value) ? 'name' : 'uid'
                            let index = _.findIndex(this.selection, o => { return o[key] === value })
                            if (index < 0) {
                                return
                            }
                            this.$refs.selectionTable.toggleRowSelection(this.selection[index], true)
                        })
                    }/*  else {
                        this.$refs.selectionTable.clearSelection()
                    } */
                    this.selecting = false
                })
            },
            handleSelectionChange (val) {
                if (this.selecting) {
                    return
                }
                if (this.single) {
                    if (!val || val.length === 0) {
                        this.selected = []
                    } else if (val.length === 1 && this.selected.length === 1 && val[0] === this.selected[0]) {
                        return;
                    } else {
                        let sel = [];
                        for (let i = 0; i < val.length; i++) {
                            let at = false
                            for (let j = 0; j < this.selected.length; j++) {
                                let value = this.selected[j]
                                if (_.isObject(value)) {
                                    value = value.uid || null
                                }
                                let key = _.isString(value) ? 'name' : 'uid'
                                if (val[i][key] === value) {
                                    at = true
                                    break
                                }
                            }
                            if (!at) {
                                sel.push(val[i])
                            }
                        }
                        this.selected = sel
                        this.selectTable()
                    }
                } else {
                    this.selected = val || []
                }
            },
            submit () {
                if (this.saving) {
                    return
                }
                let value = []
                if (!this.valueKey) {
                    this.displayed = false
                    return
                }
                this.saving = true
                let anesthesiaAdditional = null
                _.forEach(this.selected, item => {
                    if (!_.isObject(item)) {
                        value.push(item)
                        if (this.additionals && this.additionals.length) {
                            anesthesiaAdditional = this.additionalMap[item]
                        }
                        return
                    }
                    if (this.type === 'anesthesiaType') {
                        value.push(item.name)
                        if (this.additionals && this.additionals.length) {
                            anesthesiaAdditional = this.additionalMap[item.name]
                        }
                    } else {
                        value.push(item.uid)
                    }
                })
                if (_.isEqual(this.old, value) && (!this.additionals || !this.additionals.length || this.operation.anesthesiaAdditional === anesthesiaAdditional)) {
                    this.displayed = false
                    this.saving = false
                    return
                }
                let operation = _.cloneDeep(this.operation)
                operation[this.valueKey] = _.isEmpty(value) ? null : _.join(value)
                if (this.nameKey) {
                    operation[this.nameKey] = null
                }
                if (anesthesiaAdditional) {
                    operation.anesthesiaAdditional = anesthesiaAdditional
                }
                OperationService.save(operation).then(res => {
                    operation = res.result || {}
                    this.$emit('saveDone', operation)
                    this.displayed = false
                }).catch(error => {
                    this.$message.error(error || '保存信息失败')
                }).finally(() => {
                    this.saving = false
                })
            }
        }
    }
</script>

<template>
  <el-popover
    :width="additionals && additionals.length ? '320' : '240'"
    :title="title"
    v-model="displayed"
    trigger="click">
<!--                :height="type === 'anesthesiaType' ? 180 : 260"-->
      <el-table
        ref="selectionTable"
        class="selection-table"
        :data="selection"
        :show-header="false"
        row-key="uid"
        stripe
        size="small"
        @selection-change="handleSelectionChange"
        style="width: 100%">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column prop="additional" label="操作" v-if="additionals && additionals.length">\
            <template slot-scope="scope">
                <el-select v-model="additionalMap[scope.row.name]" size="mini" placeholder="请选择">
                    <el-option
                        v-for="item in additionals"
                        :key="item.operation"
                        :label="item.operation"
                        :value="item.operation">
                    </el-option>
                </el-select>
            </template>
        </el-table-column>
      </el-table>
    <div class="bnts">
      <el-button type="primary" size="small" :loading="saving" @click="submit()">{{saving ? '提交中...' : '确 定'}}</el-button>
    </div>
    <p class="show-text" :class="{ blue: old.length > 0 }" slot="reference">{{text}}</p>
  </el-popover>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .bnts {
      padding: 10px 20px;
      text-align: center;
  }
  .show-text {
      color: #dd1144;
      cursor: pointer;
  }
  .show-text.blue {
      color: #409EFF;
  }
  .selection-table >>> .el-table__body-wrapper {
    max-height: 200px;
    overflow-y: auto;
  }
</style>
